import { EQuizDifficulty, EQuizMode, EQuizStatus } from '@constants';

export const ManagerQuizzesTranslations = {
  TEST: {
    es: 'Test',
    en: 'Test',
    cat: 'Test',
    eus: 'Test',
    pt: 'Teste'
  },
  TESTS: {
    es: 'Tests',
    en: 'Tests',
    cat: 'Tests',
    eus: 'Testak',
    pt: 'Testes'
  },
  ALL_TESTS: {
    es: 'Todos los tests',
    en: 'All tests',
    cat: 'Tots els tests',
    eus: 'Test guztiak',
    pt: 'Todos os testes'
  },
  CREATE_QUIZ: {
    es: 'Crear test',
    en: 'Create test',
    cat: 'Crear test',
    eus: 'Testa sortu',
    pt: 'Criar teste'
  },
  EDIT_QUIZ: {
    es: 'Editar test',
    en: 'Edit test',
    cat: 'Editar test',
    eus: 'Testa aldatu',
    pt: 'Editar teste'
  },
  DUPLICATE_QUIZ: {
    es: 'Duplicar test',
    en: 'Duplicate test',
    cat: 'Duplicar test',
    eus: 'Testa bikoiztu',
    pt: 'Duplicar teste'
  },

  PASS_DRAFT_QUIZ: {
    es: 'Pasar a borrador',
    en: 'Pass to draft',
    cat: 'Passar a borrador',
    eus: 'Pasatu borrok',
    pt: 'Passar para rascunho'
  },

  CREATE: {
    es: 'Crear',
    en: 'Create',
    cat: 'Crear',
    eus: 'Sortu',
    pt: 'Criar'
  },
  TITLE: {
    es: 'Título',
    en: 'Title',
    cat: 'Títol',
    eus: 'Izenburua',
    pt: 'Título'
  },
  NUMBER_OF_QUESTIONS: {
    es: 'Número de preguntas',
    en: 'Number of questions',
    cat: 'Número de preguntes',
    eus: 'Galdera kopurua',
    pt: 'Número de questões'
  },
  DATE: {
    es: 'Fecha',
    en: 'Date',
    cat: 'Data',
    eus: 'Data',
    pt: 'Data'
  },
  ACTIONS: {
    es: 'Acciones',
    en: 'Actions',
    cat: 'Accions',
    eus: 'Ekintzak',
    pt: 'Ações'
  },
  DELETE_QUIZ: {
    es: 'Eliminar test',
    en: 'Delete test',
    cat: 'Eliminar test',
    eus: 'Testa ezabatu',
    pt: 'Excluir teste'
  },
  ARE_YOU_SURE_WANT_TO_REMOVE_QUIZ: {
    es: '¿Estás seguro de que quieres eliminar el test?',
    en: 'Are you sure you want to remove the test?',
    cat: 'Estàs segur que vols eliminar el test?',
    eus: 'Zihur zaude testa ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja excluir o teste?'
  },
  QUIZ_REMOVED_SUCCESSFULLY: {
    es: 'Test eliminado correctamente',
    en: 'Test removed successfully',
    cat: 'Test eliminat correctament',
    eus: 'Testa ongi ezabatu da',
    pt: 'O teste foi excluído com sucesso'
  },
  NO_QUIZZES_FOUND: {
    es: 'No se han encontrado tests',
    en: 'No quizzes found',
    cat: 'No s`han trobat tests',
    eus: 'Ez da testik aurkitu',
    pt: 'Não foram encontrados testes'
  },

  NO_QUIZZES_ADDED: {
    es: 'Aún no has creado tests',
    en: "You still haven't created any tests",
    cat: 'Encara no has creat cap test',
    eus: 'Ez dituzu testik sortu',
    pt: 'Ainda não criou nenhum teste'
  },

  NO_QUIZZES_ADDED_DESCRIPTION: {
    es: 'Empieza a crear test para potenciar el aprendizaje de tus alumnos.',
    en: 'Start creating tests to enhance the learning of your students.',
    cat: 'Comença a crear tests per millorar el coneixement dels teus alumnes.',
    eus: 'Test bat sortu Pulse erabiltzeko hasi nahi duzula.',
    pt: 'Crie um teste para começar a usar Pulse.'
  },
  QUIZZES_TOTAL_COUNT: {
    es: '{{total}} tests',
    en: '{{total}} tests',
    cat: '{{total}} tests',
    eus: '{{total}} test',
    pt: '{{total}} testes'
  },
  SEARCH_PLACEHOLDER: {
    es: 'Buscar',
    en: 'Search',
    cat: 'Cercar',
    eus: 'Bilatu',
    pt: 'Pesquisar'
  },
  SEND: {
    es: 'Enviar',
    en: 'Send',
    cat: 'Enviar',
    eus: 'Bidali',
    pt: 'Enviar'
  },
  UPLOAD_CSV_FILE: {
    es: 'Sube un archivo en formato .csv',
    en: 'Upload a .csv file',
    cat: 'Puja un fitxer en format .csv',
    eus: 'Igo .csv formatuko fitxategi bat',
    pt: 'Carregar um arquivo .csv'
  },
  QUIZ_CREATED_SUCCESSFULLY: {
    es: 'Test creado correctamente',
    en: 'Quiz created successfuly',
    cat: 'Test creat correctament',
    eus: 'Testa ongi sortu da',
    pt: 'O teste foi criado com sucesso'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Ezeztatu',
    pt: 'Cancelar'
  },
  CANCEL_CONFIRMATION_MSG_1: {
    es: '¿Seguro que quieres descartar las preguntas?',
    en: 'Are you sure you want to discard the questions?',
    cat: 'Estàs segur que vols descartar les preguntes?',
    eus: 'Ziur zaude galderak baztertu nahi dituzula?',
    pt: 'Tem certeza que deseja descartar as questões?'
  },
  CANCEL_CONFIRMATION_MSG_2: {
    es: 'Se borrarán las preguntas importadas',
    en: 'Imported questions will be deleted',
    cat: 'Es borraran les preguntes importades',
    eus: 'Galderak ezabatuko dira',
    pt: 'As questões importadas serão excluídas'
  },
  RETURN: {
    es: 'Volver',
    en: 'Return',
    cat: 'Tornar',
    eus: 'Itzuli',
    pt: 'Voltar'
  },
  SAVE: {
    es: 'Guardar',
    en: 'Save',
    cat: 'Guardar',
    eus: 'Gorde',
    pt: 'Guardar'
  },
  DISCARD: {
    es: 'Descartar',
    en: 'Discard',
    cat: 'Descartar',
    eus: 'Baztertu',
    pt: 'Descartar'
  },
  QUIZ_UPDATED: {
    es: 'Sección actualizada con éxito',
    en: 'Section successfully updated',
    cat: 'Secció actualitzada amb èxit',
    eus: 'Atala ongi eguneratua',
    pt: 'A seção foi atualizada com sucesso'
  },
  STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  SET_AS_PUBLISHED: {
    es: 'Marcar como publicado',
    en: 'Set as published',
    cat: 'Marcar com a publicat',
    eus: 'Markatu publikatua',
    pt: 'Marcar como publicado'
  },
  SET_AS_DRAFT: {
    es: 'Marcar como borrador',
    en: 'Set as draft',
    cat: 'Marcar com a borrador',
    eus: 'Markatu borrador',
    pt: 'Marcar como borrador'
  },
  QUIZ_UPDATED_SUCCESSFULLY: {
    es: 'Test actualizado correctamente',
    en: 'Test updated successfully',
    cat: 'Test actualitzat correctament',
    eus: 'Testa ongi eguneratua',
    pt: 'O teste foi atualizado com sucesso'
  },
  QUIZ_DUPLICATED_SUCCESSFULLY: {
    es: 'Test duplicado correctamente',
    en: 'Test duplicated successfully',
    cat: 'Test duplicat correctament',
    eus: 'Testa ongi bikoiztua',
    pt: 'O teste foi duplicado com sucesso'
  },
  MODE: {
    es: 'Tipo',
    en: 'Type',
    cat: 'Tipus',
    eus: 'Mota',
    pt: 'Tipo'
  },
  [EQuizMode.QUIZ]: {
    es: 'Quiz',
    en: 'Quiz',
    cat: 'Quiz',
    eus: 'Quiz',
    pt: 'Quiz'
  },
  [EQuizMode.PRACTICE]: {
    es: 'Simulacro',
    en: 'Simulator',
    cat: 'Simulacre',
    eus: 'Simulazio',
    pt: 'Simulador'
  },
  [EQuizMode.TRUE_FALSE]: {
    es: 'Verdadero o Falso',
    en: 'True or False',
    cat: 'Veritat o Fals',
    eus: 'Egia edo Derrus',
    pt: 'Verdadeiro ou Falso'
  },
  [EQuizMode.PRACTICAL_CASE]: {
    es: 'Caso Práctico',
    en: 'Practical Case',
    cat: 'Cas Pràctic',
    eus: 'Praktike kasua',
    pt: 'Caso Prático'
  },
  [EQuizMode.LIGHTNING]: {
    es: 'Relámpago',
    en: 'Lightning',
    cat: 'Llampada',
    eus: 'Ikasti',
    pt: 'Relâmpago'
  },
  CREATOR: {
    es: 'Creador',
    en: 'Creator',
    cat: 'Creador',
    eus: 'Sortzailea',
    pt: 'Criador'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Ikastaroa',
    pt: 'Curso'
  },
  COURSE_SEARCH_PLACEHOLDER: {
    es: 'Cursos',
    en: 'Courses',
    cat: 'Cursos',
    eus: 'Ikastarok',
    pt: 'Cursos'
  },
  SECTION_SEARCH_PLACEHOLDER: {
    es: 'Temas',
    en: 'Themes',
    cat: 'Temes',
    eus: 'Gaiak',
    pt: 'Temas'
  },
  SECTION: {
    es: 'Sección',
    en: 'Section',
    cat: 'Secció',
    eus: 'Atala',
    pt: 'Seção'
  },
  [EQuizStatus.PUBLISHED]: {
    es: 'Publicado',
    en: 'Published',
    cat: 'Publicat',
    eus: 'Publikatua',
    pt: 'Publicado'
  },
  [EQuizStatus.DRAFT]: {
    es: 'Borrador',
    en: 'Draft',
    cat: 'Borrador',
    eus: 'Borrador',
    pt: 'Borrador'
  },
  FILTERS: {
    es: 'Filtros',
    en: 'Filters',
    cat: 'Filtres',
    eus: 'Iragaziak',
    pt: 'Filtros'
  },
  DIFFICULTY: {
    es: 'Dificultad',
    en: 'Difficulty',
    cat: 'Dificultat',
    eus: 'Zailtasuna',
    pt: 'Dificuldade'
  },
  [EQuizDifficulty.HARD]: {
    es: 'Difícil',
    en: 'Hard',
    cat: 'Difícil',
    eus: 'Zaila',
    pt: 'Difícil'
  },
  [EQuizDifficulty.MEDIUM]: {
    es: 'Media',
    en: 'Medium',
    cat: 'Mitja',
    eus: 'Ertaina',
    pt: 'Média'
  },
  [EQuizDifficulty.EASY]: {
    es: 'Fácil',
    en: 'Easy',
    cat: 'Fàcil',
    eus: 'Errota',
    pt: 'Fácil'
  },
  AVERAGE_SCORE: {
    es: 'Nota media',
    en: 'Average score',
    cat: 'Nota mitjana',
    eus: 'Batezbesteko puntuazioa',
    pt: 'Média'
  },
  COMPLETED_QUIZZES: {
    es: 'Completado',
    en: 'Completed',
    cat: 'Completat',
    eus: 'Egin daitezen aldiz',
    pt: 'Completado'
  },
  CLEAR_FILTERS: {
    es: 'Borrar filtros',
    en: 'Clear filters',
    cat: 'Borrar filtres',
    eus: 'Ezabatu iragaziak',
    pt: 'Limpar filtros'
  },
  [`QUIZZES_TABLE_${EQuizMode.QUIZ}`]: {
    es: '🎯 Quiz',
    en: '🎯 Quiz',
    cat: '🎯 Quiz',
    eus: '🎯 Quiz',
    pt: '🎯 Quiz'
  },
  [`QUIZZES_TABLE_${EQuizMode.PRACTICE}`]: {
    es: '⏳ Simulacro',
    en: '⏳ Simulator',
    cat: '⏳ Simulacre',
    eus: '⏳ Simulazio',
    pt: '⏳ Simulador'
  },
  [`QUIZZES_TABLE_${EQuizMode.TRUE_FALSE}`]: {
    es: '🏓 V / F',
    en: '🏓 T / F',
    cat: '🏓 V / F',
    eus: '🏓 T / F',
    pt: '🏓 V / F'
  },
  [`QUIZZES_TABLE_${EQuizMode.PRACTICAL_CASE}`]: {
    es: '📋 Caso Práctico',
    en: '📋 Practical Case',
    cat: '📋 Cas Pràctic',
    eus: '📋 Praktike kasua',
    pt: '📋 Caso Prático'
  },
  [`QUIZZES_TABLE_${EQuizMode.LIGHTNING}`]: {
    es: '⚡️ Relámpago',
    en: '⚡️ Lightning',
    cat: '⚡️ Llampada',
    eus: '⚡️ Ikasti',
    pt: '⚡️ Relâmpago'
  },
  [`${EQuizMode.QUIZ}_MODE_DESCRIPTION`]: {
    es: 'Crea preguntas de opción múltiple con una respuesta correcta.',
    en: 'Create multiple choice questions with one correct answer.',
    cat: 'Crea preguntes de opció múltiple amb una resposta correcta.',
    eus: 'Ezabatu galdera bat.',
    pt: 'Crie questões de múltipla escolha com uma resposta correta.'
  },
  [`${EQuizMode.PRACTICE}_MODE_DESCRIPTION`]: {
    es: 'Crea preguntas de opción múltiple con tiempo límite.',
    en: 'Create multiple choice questions with time limit.',
    cat: 'Crea preguntes de opció múltiple amb temps limitat.',
    eus: 'Ezabatu galdera bat.',
    pt: 'Crie questões de múltipla escolha com um tempo limite.'
  },
  [`${EQuizMode.TRUE_FALSE}_MODE_DESCRIPTION`]: {
    es: 'Crea afirmaciones y define si son verdaderas o falsas.',
    en: 'Create statements and define if they are true or false.',
    cat: 'Crea afirmacions i defineix si són certes o falses.',
    eus: 'Ezabatu galdera bat.',
    pt: 'Crie afirmações e defina se são verdadeiras ou falsas.'
  },
  [`${EQuizMode.PRACTICAL_CASE}_MODE_DESCRIPTION`]: {
    es: 'Crea preguntas de opción múltiple relacionadas con un caso práctico.',
    en: 'Create multiple choice questions related to a practical case.',
    cat: 'Crea preguntes de opció múltiple relacionades amb un cas pràctic.',
    eus: 'Ezabatu galdera bat.',
    pt: 'Crie questões de múltipla escolha relacionadas com um caso prático.'
  },
  SELECT_MODE: {
    es: 'Elige un tipo de test',
    en: 'Select a quiz type',
    cat: 'Elige un tipus de test',
    eus: 'Ezabatu galdera bat.',
    pt: 'Selecione um tipo de teste'
  },
  MODE_OPTIONS: {
    es: 'Ajustes del {{mode}}',
    en: 'Settings for {{mode}}',
    cat: 'Ajustos del {{mode}}',
    eus: '{{mode}} ezarpenak',
    pt: 'Ajustes para {{mode}}'
  },
  ADD_QUESTIONS: {
    es: 'Añadir preguntas a {{name}}',
    en: 'Add questions to {{name}}',
    cat: 'Añadir preguntes a {{name}}',
    eus: 'Galderak gehitu {{name}}',
    pt: 'Adicionar questões a {{name}}'
  },
  MANUAL_QUESTION_GENERATION: {
    es: 'Crear preguntas a mano',
    en: 'Create questions manually',
    cat: 'Crear preguntes a mà',
    eus: 'Galderak eskubidez sortu',
    pt: 'Criar questões manualmente'
  },
  MANUAL_QUESTION_GENERATION_DESCRIPTION: {
    es: 'Escribe tus propias preguntas o usa las que ya creaste.',
    en: 'Write your own questions or use the ones you have already created.',
    cat: 'Escriu les teves preguntes o utilitza les que ja has creat.',
    eus: 'Eskubidez sortu galderak edo egin dituzun galderak erabiliz.',
    pt: 'Escreva suas próprias questões ou use as que já criou.'
  },
  IMPORT_FILE: {
    es: 'Importar un archivo',
    en: 'Import a file',
    cat: 'Importar un fitxer',
    eus: 'Fitxategu inportatu',
    pt: 'Importar um arquivo'
  },
  IMPORT_FILE_DESCRIPTION: {
    es: 'Sube el test en formato CSV.',
    en: 'Upload the test in CSV format.',
    cat: 'Puja el test en format CSV.',
    eus: 'Igo .CSV formatuko testa.',
    pt: 'Carregue o teste em formato CSV.'
  },
  AI_QUESTION_GENERATION: {
    es: 'Generar preguntas con IA',
    en: 'Generate questions with AI',
    cat: 'Generar preguntes amb IA',
    eus: 'Galderak IA erabiliz sortu',
    pt: 'Gerar questões com IA'
  },
  AI_QUESTION_GENERATION_DESCRIPTION: {
    es: 'Crea preguntas de forma automática en segundos.',
    en: 'Create questions automatically in seconds.',
    cat: 'Crea preguntes automàticament en segons.',
    eus: 'Galderak IA erabiliz sortu',
    pt: 'Gerar questões automaticamente em segundos.'
  },
  IMPORT_QUESTIONS_FOR: {
    es: 'Importar preguntas para {{name}}',
    en: 'Import questions for {{name}}',
    cat: 'Importar preguntes per a {{name}}',
    eus: 'Galderak gehitu {{name}}',
    pt: 'Importar questões para {{name}}'
  },
  SELECT_FILES: {
    es: 'Selecciona archivos',
    en: 'Select files',
    cat: 'Selecciona fitxers',
    eus: 'Fitxategiak aukeratu',
    pt: 'Selecione arquivos'
  },
  SELECT_FILES_DESCRIPTION: {
    es: 'Se crearán preguntas a partir de los archivos seleccionados.',
    en: 'Questions will be generated from the selected files.',
    cat: 'Les preguntes es crearan a partir dels fitxers seleccionats.',
    eus: 'Galderak fitxategiak erabiliz sortu',
    pt: 'As questões serão geradas a partir dos arquivos selecionados.'
  },
  NO_FILES: {
    es: 'No se han encontrado archivos en esta sección',
    en: 'No files found in this section',
    cat: 'No hi ha fitxers en aquesta secció',
    eus: 'Ez da fitxategi bat aurkitu atal honetan',
    pt: 'Não foram encontrados arquivos nesta seção'
  },
  BACK: {
    es: 'Volver',
    en: 'Back',
    cat: 'Tornar',
    eus: 'Itzuli',
    pt: 'Voltar'
  },
  SELECT_ALL: {
    es: 'Seleccionar todos',
    en: 'Select all',
    cat: 'Seleccionar tots',
    eus: 'Guztira aukeratu',
    pt: 'Selecionar todos'
  },
  GENERATING_QUESTIONS: {
    es: 'Generando preguntas...',
    en: 'Generating questions...',
    cat: 'Generant preguntes...',
    eus: 'Galderak sortzen...',
    pt: 'Gerando questões...'
  },
  IT_CAN_TAKE_UP_TO_A_MINUTE: {
    es: 'Esto puede tardar hasta un minuto',
    en: 'This can take up to a minute',
    cat: 'Això pot tardar fins a un minut',
    eus: 'Minutu batzuetan egin daiteke',
    pt: 'Pode levar até um minuto'
  },
  IMPORT_QUESTIONS: {
    es: 'Importar preguntas',
    en: 'Import questions',
    cat: 'Importar preguntes',
    eus: 'Galderak inportatu',
    pt: 'Importar questões'
  },
  COMPLETE_THE_TEMPLATE: {
    es: 'Completa la plantilla',
    en: 'Complete the template',
    cat: 'Completa el model',
    eus: 'Ezabatu galdera bat.',
    pt: 'Complete o modelo'
  },
  COMPLETE_THE_TEMPLATE_DESCRIPTION: {
    es: 'Sigue las <a>instrucciones para usar la plantilla</a> de forma correcta.',
    en: 'Follow the <a>instructions to use the template</a> correctly.',
    cat: 'Sigue les <a>instruccions per utilitzar el model</a> correctament.',
    eus: 'Jarraitu <a>jarraibideei txantiloia zuzen erabiltzeko</a>.',
    pt: 'Siga as <a>instruções para usar o modelo</a> corretamente.'
  },
  OPEN_TEMPLATE: {
    es: 'Abrir plantilla',
    en: 'Open template',
    cat: 'Obrir model',
    eus: 'Ireki txantiloia',
    pt: 'Abrir modelo'
  },
  IMPORT_CSV_ERROR_MESSAGE: {
    es: 'Error al importar el CSV en las siguientes filas:',
    en: 'Error importing the CSV in the following rows:',
    cat: 'Error al importar el CSV en les següents files:',
    eus: 'Errore CSV inportatzeko atal honetan:',
    pt: 'Erro ao importar o CSV nas seguintes linhas:'
  },
  ROW_NUMBER: {
    es: 'Fila {{number}}',
    en: 'Row {{number}}',
    cat: 'Fila {{number}}',
    eus: 'Atala {{number}}',
    pt: 'Linha {{number}}'
  },
  UPLOAD_FILE: {
    es: 'Subir archivo',
    en: 'Upload file',
    cat: 'Pujar fitxer',
    eus: 'Fitxategu inportatu',
    pt: 'Carregar arquivo'
  },
  ACKNOWLEDGED: {
    es: 'Entendido',
    en: 'Acknowledged',
    cat: 'Entés',
    eus: 'Ezagutu',
    pt: 'Entendido'
  },
  IMPORT_INSTRUCTIONS_1: {
    es: '<a>Abre</a> la plantilla.',
    en: '<a>Open</a> the template.',
    cat: '<a>Obre</a> el model.',
    eus: '<a>Ireki</a> txantiloia.',
    pt: '<a>Abra</a> o modelo.'
  },
  IMPORT_INSTRUCTIONS_2: {
    es: '<a>Haz una copia</a> del archivo para poder editarlo.',
    en: '<a>Make a copy</a> of the file to be able to edit it.',
    cat: '<a>Fes una còpia</a> del fitxer per poder editar-lo.',
    eus: '<a>Kopia</a> fitxategi bat gurekin egin.',
    pt: '<a>Faça uma cópia</a> do arquivo para poder editá-lo.'
  },
  IMPORT_INSTRUCTIONS_3: {
    es: 'Completa los campos y <a>descarga el archivo en formato CSV.</a>',
    en: 'Complete the fields and <a>download the file in CSV format.</a>',
    cat: 'Completa els camps i <a>descarrega el fitxer en format CSV.</a>',
    eus: 'Bete eremuak eta <a>deskargatu fitxategia CSV formatuan.</a>',
    pt: 'Complete os campos e <a>descarregue o arquivo em formato CSV.</a>'
  },
  IMPORT_INSTRUCTIONS_4: {
    es: '<a>Sube el archivo</a> a la plataforma.',
    en: '<a>Upload the file</a> to the platform.',
    cat: '<a>Puja el fitxer</a> a la plataforma.',
    eus: '<a>Igo fitxategu bat</a> egin daiteke.',
    pt: '<a>Carregue o arquivo</a> para a plataforma.'
  },
  CONSIDERATIONS: {
    es: 'Consideraciones',
    en: 'Considerations',
    cat: 'Considerem',
    eus: 'Kontuan hartu',
    pt: 'Considereções'
  },
  QUIZ_CONSIDERATIONS_1: {
    es: 'Los test pueden tener entre 2 y 5 respuestas. Todas las preguntas deben tener el mismo número de opciones de respuesta.',
    en: 'Tests can have between 2 and 5 answers. All questions must have the same number of answer options.',
    cat: "Els tests poden tenir entre 2 i 5 respostes. Totes les preguntes han de tenir el mateix nombre d'opcions de resposta.",
    eus: 'Probek 2 eta 5 erantzun artean izan ditzakete. Galdera guztiek erantzun aukera kopuru bera izan behar dute.',
    pt: 'Os testes podem ter entre 2 e 5 respostas. Todas as perguntas devem ter o mesmo número de opções de resposta.'
  },
  QUIZ_CONSIDERATIONS_2: {
    es: 'Si el test tiene 2 o 3 respuestas, se deben eliminar las columnas vacías.',
    en: 'If the test has 2 or 3 answers, empty columns must be removed.',
    cat: "Si el test té 2 o 3 respostes, les columnes buides han d'eliminar-se.",
    eus: 'Testak 2 edo 3 erantzun baditu, zutabe hutsak kendu behar dira.',
    pt: 'Se o teste tiver 2 ou 3 respostas, as colunas vazias devem ser removidas.'
  },
  QUIZ_CONSIDERATIONS_3: {
    es: 'Si el test tiene 5 respuestas, es necesario añadir una columna.',
    en: 'If the test has 5 answers, an additional column must be added.',
    cat: 'Si el test té 5 respostes, és necessari afegir una columna.',
    eus: 'Testak 5 erantzun baditu, zutabe bat gehitu behar da.',
    pt: 'Se o teste tiver 5 respostas, é necessário adicionar uma coluna.'
  },
  REVIEW_CONSIDERATIONS: {
    es: 'Todos los test <a>se revisarán antes de publicarse.</a> Hemos incorporado la revisión automática para hacer el proceso más rápido.',
    en: 'All tests <a>will be reviewed before being published.</a> We have included automatic review to make the process faster.',
    cat: 'Tots els tests <a>es revisaràn abans de ser publicats.</a> Hem incorporat la revisió automàtica per fer el procés més ràpid.',
    eus: 'Testu guztiak <a>publikatzeko lehenago egiaztatuko dira.</a> Automatikoki egiaztatzea azkarratzeko, egiaztapen bat gehitu dugu.',
    pt: 'Todos os testes <a>serão revisados antes de serem publicados.</a> Incorporámos a revisão automática para acelerar o processo.'
  },
  QUIZ_PUBLISHED_SUCCESSFULLY: {
    es: 'Test publicado',
    en: 'Quiz published',
    cat: 'Test publicat',
    eus: 'Testu publikatu',
    pt: 'Teste publicado'
  },
  QUESTION_BANK: {
    es: 'Listado de preguntas',
    en: 'Question bank',
    cat: 'Banc de preguntes',
    eus: 'Galdera bankua',
    pt: 'Banco de questões'
  },
  TRUE: {
    es: 'Verdadero',
    en: 'True',
    cat: 'Verdader',
    eus: 'Egia',
    pt: 'Verdadeiro'
  },
  FALSE: {
    es: 'Falso',
    en: 'False',
    cat: 'Fals',
    eus: 'Gezur',
    pt: 'Falso'
  },
  NUMBER_OF_ANSWERS: {
    es: 'Número de respuestas',
    en: 'Number of answers',
    cat: 'Número de respostes',
    eus: 'Galdera kopurua',
    pt: 'Número de respostas'
  },
  DELETE_QUIZ_QUESTION: {
    es: '¿Eliminar test?',
    en: 'Delete quiz?',
    cat: 'Eliminar test?',
    eus: 'Testa ezabatu?',
    pt: 'Excluir teste?'
  },
  DELETE_QUIZ_DESCRIPTION: {
    es: 'El test “<bold>{{name}}</bold>” se eliminará de forma permanente.',
    en: 'The quiz “<bold>{{name}}</bold>” will be permanently deleted.',
    cat: 'El test “<bold>{{name}}</bold>” se eliminarà de forma permanent.',
    eus: 'Testa “<bold>{{name}}</bold>” betiko ezabatuko da.',
    pt: 'O teste “<bold>{{name}}</bold>” será excluído permanentemente.'
  },
  NAME: {
    es: 'Nombre',
    en: 'Name',
    cat: 'Nom',
    eus: 'Izenburua',
    pt: 'Nome'
  },
  ACTIVITY: {
    es: 'Actividad',
    en: 'Activity',
    cat: 'Activitat',
    eus: 'Jarduerak',
    pt: 'Atividade'
  },
  ACTIVITY_WHERE_COURSE_IS_USED: {
    es: 'Actividad donde se usa este test.',
    en: 'Activity where this test is used.',
    cat: 'Activitat on es fa servir aquest examen.',
    eus: 'Jarduera non test hau erabiltzen den.',
    pt: 'Atividade onde este teste é usado.'
  },
  LOCATION_INSIDE_COURSE: {
    es: 'Ubicación del test dentro del curso.',
    en: 'Location of the test inside the course.',
    cat: "Ubicació de l'examen dins del curs.",
    eus: 'Testuaren lekua ikastaroko barruan.',
    pt: 'Localização do teste dentro do curso.'
  }
};
